/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */

export const pxToPercent = (px: number | `${number}px`, base: number = 1920) => {
  let pxSize: number | string = px
  if (typeof px === 'string' && px.indexOf('px') > -1) {
    pxSize = px.replace('px', '')
  }

  return `${(Number(pxSize) / base) * 100}%` as const
}

/**
 * Convert px to viewport width
 * @param px Number or unit size to be converted
 * @param base Viewport base width in number. Default to 1920.
 */
export const pxToVw = (px: number | `${number}px`, base: number = 1920) => {
  let pxSize: number | string = px
  if (typeof px === 'string' && px.indexOf('px') > -1) {
    pxSize = px.replace('px', '')
  }

  return `${(Number(pxSize) / base) * 100}vw` as const
}

/**
 * Convert px to em
 * @param target Number or unit size to be converted
 * @param base Number where the target is relative to it
 */
export const pxToEm = (target: number | `${number}px`, base: number | `${number}px`) => {
  let targetSize: number | string = target
  if (typeof target === 'string' && target.indexOf('px') > -1) {
    targetSize = target.replace('px', '')
  }

  let baseSize: number | string = base
  if (typeof base === 'string' && base.indexOf('px') > -1) {
    baseSize = base.replace('px', '')
  }

  return `${Number(targetSize) / Number(baseSize)}em` as const
}
